export default function goToScreen(history, path = '', params = '?'){
  
  function getActualPath(path){
    if (path === "") return '';
    // if (path === "home") return '';
    if (path === "/log_out") return '/log_out';
    return "/onboarding/" + path;
  }
  
  const actual_path = getActualPath(path);
  
  if(history && actual_path !== ""){
    return history.push({
      pathname: actual_path,
      search: params
    });
  }
  
  return window.location.href = actual_path;
}